import { Brick, registerBrick } from 'olympe';
import { combineLatest } from 'rxjs';

export default class MatomoPrepareParameters extends Brick {

    /**
     * @override
     */
    setupExecution($) {
        const inputs = this.getInputs();
        return combineLatest(inputs.map((i) => $.observe(i, false)));
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} parameter1
     * @param {*} parameter2
     * @param {*} parameter3
     * @param {*} parameter4
     * @param {*} parameter5
     * @param {*} parameter6
     * @param {function(ListDef)} setParameters
     */
    update($, [parameter1, parameter2, parameter3, parameter4, parameter5, parameter6], [setParameters]) {
        const params = [];
        const addParam = (value) => {
            if (value !== null && value !== undefined) {
                params.push(value);
            }
        }
        addParam(parameter1);
        addParam(parameter2);
        addParam(parameter3);
        addParam(parameter4);
        addParam(parameter5);
        addParam(parameter6);
        setParameters(params);
    }
}

registerBrick('018804e9d9e4791c1d7d', MatomoPrepareParameters);
